import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const smartRounds: AppRouteModule = {
  path: '/',
  name: '',
  component: LAYOUT,
  redirect: '/smart-rounds',
  meta: {
    orderNo: 2,
    icon: 'data-search|svg',
    title: t('routes.nurse.smartRounds'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'smart-rounds',
      name: 'SmartRounds',
      component: () => import('/@/views/nurse/smart-rounds/index.vue'),
      meta: {
        icon: 'data-search|svg',
        title: t('routes.nurse.smartRounds'),
      },
    },
  ],
};

export default smartRounds;
